import { Head, Link } from "@inertiajs/react";
import Chat from "../../types/serializers/Chat";

export default function ChatIndex({ chats }: { chats: Chat[] }) {
  return (
    <>
      <Head title="Inertia + Vite Ruby + React Example" />

      <ul>
        {chats.map((chat, index) => (
          <li key={index}>
            {chat.id} {chat.created_at}
            <Link href={`/chats/${chat.id}`}>View</Link>
          </li>
        ))}
      </ul>
    </>
  );
}
